import { LEVEL } from '_utils/level';

export const _LOAD_NUMEREX_MODEL_ = 'Load:NumerexPuzzle';

export const TYPE_SLUG = 'numerex';

export const CELL_SIZE = 60;

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  text: null,
};

export const NUMBER_LENGTH_BOUNDS = {
  MIN: 3,
  DEFAULT_MIN: 3,
  DEFAULT_MAX: 8,
  CAP: 15,
};

export const DEFAULT_SETTINGS = {
  generation_mode: 'simple',
  min_number_length: NUMBER_LENGTH_BOUNDS.DEFAULT_MIN,
  max_number_length: NUMBER_LENGTH_BOUNDS.DEFAULT_MAX,
  prioritize_quality: true,
  number_lengths: [],
  numbers_list: '',
};

export const GENERATION_MODES = {
  SIMPLE: 'simple',
  DISTRIBUTION: 'distribution',
};

export const GENERATION_MODE_OPTIONS = [
  {
    slug: GENERATION_MODES.SIMPLE,
    labelKey: 'numerex.form.generationMode.options.simple',
  },
  {
    slug: GENERATION_MODES.DISTRIBUTION,
    labelKey: 'numerex.form.generationMode.options.distribution',
  },
];

export const getGenerationModeOption = slug =>
  GENERATION_MODE_OPTIONS.find(option => option.slug === slug) ||
  GENERATION_MODE_OPTIONS[0];

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 10,
  rows: 10,
  columns: 10,
  level: LEVEL.MEDIUM,
  settings: { ...DEFAULT_SETTINGS },
  table: [],
};

export const MIN_DIMENSIONS = {
  ROWS: 3,
  COLUMNS: 3,
};

export const MAX_DIMENSIONS = {
  ROWS: 50,
  COLUMNS: 50,
};

export const clampDimension = (value, min, max, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return Math.min(Math.max(parsed, min), max);
};

export const createEmptyCell = (x, y) => ({
  ...CELL,
  id: `cell-${x}-${y}`,
  positionx: x,
  positiony: y,
  text: null,
});

export const buildEmptyTable = (rows, columns, currentTable = []) => {
  const table = [];

  for (let y = 0; y < rows; y += 1) {
    for (let x = 0; x < columns; x += 1) {
      const existing = currentTable.find(
        c => Number(c.positionx) === x && Number(c.positiony) === y,
      );

      if (existing) {
        table.push({
          ...createEmptyCell(x, y),
          id: existing.id || `cell-${x}-${y}`,
          positionx: x,
          positiony: y,
          text:
            existing.text != null && existing.text !== ''
              ? String(existing.text)
              : null,
        });
      } else {
        table.push(createEmptyCell(x, y));
      }
    }
  }

  return table;
};

export const normalizeNumberLengths = numberLengths => {
  if (!Array.isArray(numberLengths)) {
    return [];
  }

  return numberLengths
    .map(item => ({
      length: Number(item.length),
      count: Number(item.count),
    }))
    .filter(
      item =>
        Number.isFinite(item.length)
        && Number.isFinite(item.count)
        && item.length > 0
        && item.count > 0,
    );
};
